import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {canActivateRoute} from "@core/auth/utils/canActivateRoute";
import {AuthService} from "@core/auth/services/auth/auth.service";
@Injectable({
    providedIn: 'root'
})
export class AuthenticatedOnlyGuard  {
    constructor(private authService: AuthService, private router: Router) { }
    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canNavigate(childRoute, state);
    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canNavigate(route, state);
    }

    private canNavigate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const canActivateResult = canActivateRoute(route, this.authService);
        if(canActivateResult.isAuthenticated == false)
        {
            this.router.navigate(['/'], {
                queryParams: { returnUrl: state.url }
            });
            return false;
        }
        if(canActivateResult.hasClaims == false)
        {
            this.router.navigate(['/not-authorized'], {
                queryParams: { returnUrl: state.url }
            });
            return false;
        }
        return true;
    }
}
